import { Loader } from "@mantine/core";

const Loading: React.FC = () => {
  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <Loader color="blue" />
    </div>
  );
};

export default Loading;
